var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3035 10.8428V4.69104C13.3035 4.36473 13.1738 4.05179 12.9431 3.82105C12.7124 3.59032 12.3994 3.46069 12.0731 3.46069H7.91209C7.68356 3.46069 7.45954 3.39703 7.26516 3.27685C7.07077 3.15668 6.9137 2.98474 6.81154 2.78031L6.26158 1.68038C6.15938 1.47586 6.00221 1.30386 5.8077 1.18368C5.6132 1.0635 5.38906 0.999894 5.16042 1H2.23035C1.90404 1 1.5911 1.12963 1.36036 1.36036C1.12963 1.5911 1 1.90404 1 2.23035V10.8428C1 11.1691 1.12963 11.482 1.36036 11.7128C1.5911 11.9435 1.90404 12.0731 2.23035 12.0731H12.0731C12.3994 12.0731 12.7124 11.9435 12.9431 11.7128C13.1738 11.482 13.3035 11.1691 13.3035 10.8428Z",
    stroke: "#717A97",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.82111ad61961eea1af5a5d1f4edde4d1.svg";
export { ForwardRef as ReactComponent };